import { Button, Card, Divider, Grid, List, ListItem, ListItemText, Typography, Box, IconButton, Alert, AlertTitle, Paper, Menu, MenuList, ListItemIcon, FormControlLabel, Radio, RadioGroup, Stack, Popper, Link } from "@mui/material";
import React, { useContext, useEffect, useState } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {bssMakeStyles,  width2Breakpoint } from "../../lib/theming";
import __t from "../../lib/traduzioni";
import useBSSLogger from "../../hooks/useBSSLogger";
import DefaultLoadingComponent from "../form/DefaultLoadingComponent";
import useSWRImmutable from 'swr/immutable'; 
import {cancellaContatto, cancellaIndirizzo, creaContatto, retrieveRubrica} from '../../api/rubrica'
import { Contatto, styles } from "../preventivo/frammenti/FrammentoMittDest";
import BSSStyleContext from "../../contexts/BSSStyleContext";
import BSSErrorBar from "../BSSErrorBar";
import BSSForm from "../form/BSSForm";
import { WaitKC } from "../Wrapper";
import { TreeItem, TreeView } from "@mui/lab";
import { Add, AlternateEmail, ArrowBackIos, Cancel, Check, Close, Delete, Edit, MoreVert, Phone, Settings, Star, ThumbUpAlt, WhatsApp } from "@mui/icons-material";

import BSSAutocomplete from "../form/BSSAutocomplete";
import { useTheme } from "@emotion/react";
import { DefaultSubmitErrorHandler } from "../preventivo/Preventivo";
import BSSDialog, { BSSDialogWithActions } from "../form/BSSDialog";
import { MenuItem } from "@mui/material";
import { StarBorder } from "@mui/icons-material";
import BSSMenu from "../form/BSSMenu";
import DefaultErrorComponent from "../form/DefaultErrorComponent";
import BSSButton from "../form/BSSButton";
import { Fragment } from "react";

const {logger} = useBSSLogger();

const MittDestEnum = {
    "M": {text: __t("mittente"), value: "M"},
    "D": {text: __t("destinatario"), value: "D"},
    "E": {text: __t("entrambe"), value: "E"}
}

const Rubrica = ({}) => {

    return (
        <>
            <WaitKC>
                <_Rubrica />
            </WaitKC>        
            <BSSErrorBar />
        </>
    )
}

const indirizzoMapper = (contatto, indirizzo, term = null) => {

    const { ragionesociale } = contatto;
    const { proponiper } = indirizzo;

    const valueProponiper = proponiper?.value ?? proponiper ?? "E";

    const mittente = valueProponiper === 'M';
    const destinatario = valueProponiper === 'D';

    const mittenteDefault = indirizzo.def && mittente;
    const destinatarioDefault = indirizzo.def && destinatario;

    const chiContattareLabel = `${__t("contattare")} ${indirizzo.contattare}`;
    const telefonoLabel = ![null, undefined].includes(indirizzo.prefisso) && ![null, undefined].includes(indirizzo.numero) ?  `${__t("telefono")} ${indirizzo.prefisso}-${indirizzo.numero}` : null;
    const emailLabel = ![null, undefined].includes(indirizzo.email) ? `${__t("email")} ${indirizzo.email}` : null;

    const localitaLabel = `${indirizzo.comune.nazione.nazione}, ${indirizzo.comune.cap} ${indirizzo.comune.comune} (${indirizzo.comune.provincia.iso})` ?? "";
    const indirizzoLabel = `${indirizzo.indirizzo}, ${indirizzo.civico}` ?? "";
    const contattareLabel = [chiContattareLabel, telefonoLabel, emailLabel].filter(l => l !== null).join(", ") ?? "";
    const defaultLabel = `${mittenteDefault || destinatarioDefault ? __t("default") : ''}` ?? "";
    const contattoLabel = `${mittente ? `(${__t("mittente")})` : destinatario ? `(${__t("destinatario")})` : ''} ${defaultLabel}` ?? "";

    const dettaglioIndirizzoLabel = Object.keys(indirizzo)
        .filter(chiave => ["km", "palazzina", "Scala", "interno", "ufficio_stanza", "ritiroPressoPortineria", "orarioChiusuraUfficiDa", "orarioChiusuraUfficiA", "nomeCampanello", "note"].includes(chiave))
        .reduce((arr, chiave) => {

            let currLabel = ""
            const val = indirizzo[chiave];

            let newArr = [...arr];

            if(val !== null){
                let valore = val;

                if(["ritiroPressoPortineria"].includes(chiave)){
                    logger.debug("valore booleano", chiave, val);
                    valore = __t([true, "TRUE", "true"].includes(val) ? "si" : "no")
                }

                currLabel = `${__t(chiave)}: ${valore}`;
                newArr = [...newArr, currLabel];
            }

            return newArr;

        }, []).join(", ") ?? "";

    const label = (
        <>
            <div>
                <b>{contattoLabel.toUpperCase()}</b>
            </div>
            <div>
                {indirizzoLabel.toUpperCase()} {localitaLabel.toUpperCase()}                     
            </div>                                
            <div>
                <small>
                    {dettaglioIndirizzoLabel.toUpperCase()}
                </small>
            </div>
        
            <div>
                {contattareLabel.toUpperCase()}
            </div>
            
        </>
    );

    return {
        ...indirizzo,
        proponiper,
        ragionesociale,
        mittente,
        mittenteDefault,
        destinatario,
        destinatarioDefault,
        contattareParts: {
            chiContattareLabel,
            telefonoLabel,
            emailLabel
        },
        labelParts: {
            defaultLabel,
            contattoLabel, 
            localitaLabel,
            indirizzoLabel,
            contattareLabel,
            dettaglioIndirizzoLabel,
        },
        label
    }
        
}

const listaContattiPicker = contatti => {
    return contatti.reduce((lista, contatto) => {

        const {listaindirizzi} = contatto;


        return [
            ...lista,
            ...(listaindirizzi.map(indirizzo => indirizzoMapper(contatto, indirizzo)))
        ]
    }, [])
}

const _Rubrica = ({cardWrapper = true, inPreventivo = false}) => {

    let classes = bssMakeStyles();

    const [statoLista, setStatoLista] = useState({contattoSelezionato: {}, indirizzoSelezionato: null, indSelMode: null})
    

    const datiDefault = async () => {

        let dati = {};

        let contatti = await retrieveRubrica();

        const ragionisociali = Object.keys(contatti.reduce((obj, contatto) => ({...obj, [contatto.ragionesociale]: contatto}), {}));

        contatti = ragionisociali.reduce((arr, ragionesociale) => {

            const contatto = {
                id: ragionesociale,
                ragionesociale,
                listaindirizzi: contatti.filter(contatto => contatto.ragionesociale === ragionesociale)
            }

            return [
                ...arr,
                contatto
            ]
        }, [])

        dati = {
            contatti
        };

        logger.debug("dati di default e da shortcode", dati)

        
        return dati;

        
    };

    

    


    const { data, error, mutate: ricaricaContatti } = useSWRImmutable("/api/initialDataRubrica", datiDefault, {
        onErrorRetry: (error, key, config, revalidate) => {
            return 
            // if(error === "NO_PREVIOUS_DATA"){
            //     logger.debug("non ho dati pregressi!")
            //     return
            // }
        },
        onSuccess: ({contatti=[]}) => {
            logger.debug("contatti ricaricati", data);
            const idContattoSelezionato = statoLista?.contattoSelezionato?.id ?? null;
            let contattoSelezionato = {}
            if(idContattoSelezionato !== null){
                contattoSelezionato = contatti.find(contatto => contatto.id === idContattoSelezionato) ?? {};
            }

            setStatoLista({
                ...statoLista,
                contattoSelezionato,
                indirizzoSelezionato: null,
                indSelMode: null
            })
            
        }
    });


    const procediElimina = async () => {        

        const idindirizzo = statoLista?.indirizzoSelezionato?.id ?? null;
        
        if(idindirizzo !== null){
            logger.debug("procedo con l'eliminazione dell'indirizzo", idindirizzo);
            await cancellaIndirizzo(idindirizzo)
        } else {

            const idcontatto = statoLista?.contattoSelezionato?.id ?? null;

            if(idcontatto !== null){
                logger.debug("procedo con l'eliminazione del contatto", idcontatto);
                await cancellaContatto(idcontatto)
            }
        }

        await ricaricaContatti()

    }

    if(error){
        logger.error("errore reperimento dati iniziali dati fatturazione", error)        
        return <DefaultErrorComponent {...{error}} />
    }

    if(!error && !data){
        return (<DefaultLoadingComponent />)
    }    

    const {contatti = []} = data;

    
    const formTitle = statoLista?.indSelMode !== null ? `${__t(statoLista.indSelMode)} - ${(statoLista?.contattoSelezionato ?? null) === null ? __t("nuovocontatto") : __t("contatto")}` : '';


    const CardComp = cardWrapper === true ? Card : React.Fragment

    return (
        <>
            <Grid item xs={12} className={classes.formGroupBox} >
                <CardComp >   


                    <ListaContatti {...{classes, contatti, statoLista, setStatoLista, ricaricaContatti, inPreventivo}} />       
                                                                                        
                    <BSSDialogWithActions
                        style={{height: "800px", marginTop: "120px"}} fullWidth maxWidth="md" 
                        open={![null, 'elimina'].includes(statoLista?.indSelMode ?? null)} 
                        closeHandler={e => setStatoLista({...statoLista, indirizzoSelezionato: null, indSelMode: null})}
                        title={formTitle}
                    >
                        <FormNuovoContatto {...{classes, ricaricaContatti, statoLista, setStatoLista}} />
                    </BSSDialogWithActions>

                    <BSSDialog style={{marginTop: "120px"}} fullWidth maxWidth="md" 
                        open={['elimina'].includes(statoLista?.indSelMode ?? null)} 
                        onClose={e => setStatoLista({...statoLista, indirizzoSelezionato: null, indSelMode: null})}>

                        {statoLista.contattoSelezionato && (
                            <Alert severity={"error"} action={(
                                <>
                                    <Button color="error" onClick={e => procediElimina()}>
                                        <ThumbUpAlt />
                                    </Button>
                                    <Button onClick={e => setStatoLista({
                                        ...statoLista,
                                        indirizzoSelezionato: null,
                                        indSelMode: null
                                    })}>
                                        <Cancel color={"disabled"} />
                                    </Button>
                                </>
                            )}>
                                
                                {statoLista.indirizzoSelezionato ? (
                                    <>
                                        <AlertTitle>
                                            {__t("confermaelimina")} 
                                        </AlertTitle>
                                        
                                        {indirizzoMapper(statoLista.contattoSelezionato, statoLista.indirizzoSelezionato).label}
                                    </>
                                ): (
                                    <>
                                        <AlertTitle>
                                            {__t("confermaelimina")} {__t("delcontatto")} <b>{statoLista.contattoSelezionato.ragionesociale}</b> {__t("eindirizziassociati")} 
                                        </AlertTitle>
                                        
                                        
                                    </>
                                )}
                            </Alert>
                        )}
                        
                    </BSSDialog> 

                </CardComp>
            </Grid>
        </>
    )
    
}

const contattiModifica = (contatti) => {
    return contatti.reduce((arr, contatto) => {

        const {listaindirizzi, ...contattoIndirizzi} = contatto;

        return [
            ...arr,
            ...contatto.listaindirizzi.map(indirizzo => {
                
                const indirizzoEnhanced = indirizzoMapper(contatto, indirizzo)
                
                return {
                    ...indirizzo,
                    label: indirizzoEnhanced.label,
                    indirizzoCompleto: indirizzoEnhanced,
                    contatto: contattoIndirizzi,
                    indirizzoOri:  {...indirizzo}
                }
            })
        ]
    }, []).sort((a, b) => (b?.proponiper?.value ?? "E").localeCompare(a?.proponiper?.value ?? "E"))

}

/**
 * 
 * @param {*} options 
 * @param {*} term 
 * @param {("M"|"D")} tipo M sta per mittente, D per destinatario, E per entrambe
 * @param {{idnazione, cap, comune, isoprovincia}} comune 
 * @returns 
 */
const searchContatti = (options, term, tipo = null, comune = null) => {
    term = term.toUpperCase()

    let risultati = [];

    
    if(!["", null, undefined].includes(term)){

        if(tipo !== null){
            logger.debug("considero solo le voci proposte per il tipo specificato o per entrambe", tipo, options)
            options = options.filter(option => [tipo, "E"].includes(option?.proponiper?.value ?? "E"))
        }

        if(comune !== null){

            logger.debug(" considero solo le voci che hanno la stessa id nazione, la stessa iso provincia, lo stesso cap e lo stesso comune", comune)
            options = options.filter(option => {
                let esito = true;
                logger.finest("confronto", option, "e", comune)
                esito = esito && option.nazione.id === comune.idnazione;
                esito = esito && option.provincia.iso.toUpperCase() === comune.isoprovincia.toUpperCase();
                esito = esito && option.comune.cap.toUpperCase() === comune.cap.toUpperCase();
                esito = esito && option.comune.comune.toUpperCase() === comune.comune.toUpperCase();
                
                return esito;
            })
        }


        risultati = options.filter(contatto => {

            const {ragionesociale = "", proponiper = null} = contatto?.contatto ?? {};
    
            const {
                def = null,
                contattare = "",
                indirizzo = "",
                email = "",
                prefisso = "",
                numero = "",
            } = contatto;
    
            const {
                cap = "", 
                comune: comuneIndirizzo = "",   
                nazione: naz = {},
                provincia: prov = {}                 
            } = contatto?.comune ?? {};
    
            const {
                iso: isoNazioneIndirizzo = "", 
                nazione: nazioneIndirizzo = ""
            } = naz;
    
            const {
                iso: isoProvinciaIndirizzo = "", 
                provincia: provinciaIndirizzo = ""
            } = prov; 
    
            const datiRicerca = [
                ragionesociale,
                contattare,
                indirizzo,
                email,
                `${prefisso}-${numero}`,
                `${cap} ${comuneIndirizzo}`,
                `${isoNazioneIndirizzo} ${nazioneIndirizzo}`,
                `${isoProvinciaIndirizzo} ${provinciaIndirizzo}`
            ].map(k => (k ?? "").toUpperCase())
    
            const trovato = datiRicerca.reduce((esito, val) => {
                const esitocorrente = val.indexOf(term) !== -1;
                esito = esito || esitocorrente;
                logger.finest("contatto", contatto.id, "esito per ricerca di", term, "in", val, esitocorrente, esito)
                return esito;
            }                    
            , false)
    
            return trovato;
            
        })

    }
    
    logger.debug("cerco tra i contatti per", options, term, risultati)

    return risultati
}

const UsaCome = ({inPreventivo, indirizzo, contattoSelezionato, indirizzoEnhanced}) => {

    const {methods: methodsPreventivo, setMostraRubrica, indirizzoApplicato, setIndirizzoApplicato} = inPreventivo;

    const aggiornaPreventivo = (contesto, e) => {

        const suffissoContesto = contesto === 'mittente' ? 'partenza' : 'arrivo';
        const letteraContesto = contesto === 'mittente' ? 'M' : 'D';

        if(inPreventivo !== false){

            let datiContesto = {
                mittenteodestinatario: letteraContesto,
                ...indirizzo,
                contattodef: false
            }

            delete datiContesto.status;
            delete datiContesto.utente;
            delete datiContesto.insTime;
            delete datiContesto.insUser;
            delete datiContesto.updTime;
            delete datiContesto.updUser;
            delete datiContesto.multiDescr;
            delete datiContesto.dtype;
            delete datiContesto.azienda;
            delete datiContesto.esercizio;
            delete datiContesto.proponiper;

            const aggiornamento = {
                [`nazione_${suffissoContesto}`]: indirizzo.comune.nazione,
                [`comune_${suffissoContesto}`] : indirizzo.comune,
                [`cap_comune_${suffissoContesto}`] : indirizzo.comune.cap,
                [`comune_comune_${suffissoContesto}`] : indirizzo.comune.comune,
                [contesto]: datiContesto
            }

            const {methods: methodsPreventivo, setMostraRubrica, indirizzoApplicato, setIndirizzoApplicato} = inPreventivo;

            logger.debug("aggiorno il preventivo", contesto, "dall' indirizzo", indirizzo, "da", methodsPreventivo.getValues(), "a", aggiornamento);

            // methodsPreventivo.setValue(`nazione_${suffissoContesto}`, aggiornamento[`nazione_${suffissoContesto}`]);
            // methodsPreventivo.setValue(`comune_${suffissoContesto}`, aggiornamento[`comune_${suffissoContesto}`]);
            // methodsPreventivo.setValue(contesto, aggiornamento[contesto]);
            Object.keys(aggiornamento).forEach(k => {
                methodsPreventivo.setValue(k, aggiornamento[k])
            })
            //setMostraRubrica(false);
            //setIndirizzoApplicato(false);

            setIndirizzoApplicato({
                valorePreventivo: aggiornamento, 
                contesto, 
                indirizzo, 
                contattoSelezionato, 
                label: indirizzoEnhanced.label,
                labelParts: indirizzoEnhanced.labelParts
            })

            
        }
    }

    const proponiper = indirizzo?.proponiper?.value ?? indirizzo?.proponiper ?? 'E'

    return inPreventivo && (
        <>
            {/* <Button color="primary" onClick={e => {
                aggiornaPreventivo(proponiper === "D" ? "destinatario" : "mittente", e)
            }}>
                {__t("usacome", [__t(proponiper === "D" ? "destinatario" : "mittente")])}
            </Button>

            <Button color="secondary" onClick={e => {
                aggiornaPreventivo(proponiper === "D" ? "mittente" : "destinatario")
            }}>
                {__t("usacome", [__t(proponiper === "D" ? "mittente" : "destinatario")])}
            </Button> */}
            <Button variant="contained" color="primary" onClick={e => {
                aggiornaPreventivo("mittente", e)
            }}>
                {__t("usacome", [__t("mittente")])}
            </Button>

            <Button variant="contained" sx={{ml: 2}} color="secondary" onClick={e => {
                aggiornaPreventivo("destinatario", e)
            }}>
                {__t("usacome", [__t("destinatario")])}
            </Button>
        </>

    )

    
}

const NavigaContatti = ({contatti, setStatoLista, inPreventivo = false, menuAzioniContatto, setMenuAzioniContatto}) => {

    const methods = useForm();
    const theme = useTheme();

    const contattiOri = [...contatti];

    /**
     * dato un indirizzo recupera il contatto dalla lista dei contatti
     * 
     * @param {*} indirizzo 
     */
    const contattoByIndirizzo = indirizzo => {

        logger.debug("trovo il contatto associato all'indirizzo", indirizzo, "tra i contatti", contattiOri)

        return contattiOri.find(contatto => {
            logger.debug("controllo che l'indirizzo appartenga al contatto", contatto)
            return (contatto?.listaindirizzi ?? []).find(indirizzoContatto => indirizzoContatto.id === indirizzo.id)
        })
    }

    const stopPropagation = e => {
        e.preventDefault();
        e.stopPropagation();
        e.nativeEvent.stopImmediatePropagation();
    }

    const operazioneContatto = (e, nuovoStato) => {
        //stopPropagation(e);        
        setStatoLista(nuovoStato)
    }

    const statoDefault = {
        contattoSelezionato: {},
        indirizzoSelezionato: null,
        indSelMode: null
    }

    const vediContatto = (e, contattoSelezionato) => {
        operazioneContatto(e, {
            ...statoDefault,
            contattoSelezionato,            
        })
    }

    const eliminaContatto = (e, contattoSelezionato) => {
        operazioneContatto(e, {
            ...statoDefault,
            contattoSelezionato,
            indSelMode: "elimina"
        })
    }

    const eliminaIndirizzo = (e, contattoSelezionato, indirizzoSelezionato) => {
        operazioneContatto(e, {
            ...statoDefault,
            contattoSelezionato,
            indirizzoSelezionato,
            indSelMode: "elimina"
        })
    }

    const modificaIndirizzo = (e, contattoSelezionato, indirizzoSelezionato) => {
        operazioneContatto(e, {
            ...statoDefault,
            contattoSelezionato,
            indirizzoSelezionato,
            indSelMode: "modifica"
        })
    }

    const creaIndirizzo = (e, contattoSelezionato) => {
        operazioneContatto(e, {
            ...statoDefault,
            contattoSelezionato,
            indSelMode: "crea"
        })
    }
            
    

    contatti = contattiModifica(contatti)

    
    const [popperSearchSettings, setPopperSearchSettings] = useState({anchorEl: null, open: false})
    const [mostraSolo, setMostraSolo] = useState("E")
    const mappaTipi = {"M": __t("solomittenti"), "D": __t("solodestinatari"), "E": __t("tutti")}
    const tipoLabel = mappaTipi[mostraSolo];
    let label = `${__t("cercacontatti")}`;
    logger.debug("tipo contatti tra cui ricercare", mostraSolo, tipoLabel)
    if(mostraSolo !== "E" && tipoLabel !== undefined){
        label += ` (${tipoLabel})`
    }
    const parametroTipoSearchContatti = mostraSolo !== "E" ? mostraSolo : null;

    const MenuProps = {
        ...popperSearchSettings,
        onClose: e => setPopperSearchSettings({anchorEl: null, open: false}) 
    }

    return (
        <FormProvider {...methods}>
            <BSSForm> 
                <Grid container> 
                    <Grid item style={{flexGrow: 1}}>
                        <BSSAutocomplete
                            name={"ricercaContatti"}
                            label={label} 
                            methods={methods}
                            dataProvider={async () => {         
                                return [...contatti];
                            }}     
                            TextFieldInputProps={{
                                startAdornment: (
                                    <>
                                        <Button sx={{minWidth: 0, padding: 0.1}} onClick={e => setPopperSearchSettings({anchorEl: e.currentTarget, open: true})}>
                                            <Settings />
                                        </Button>
                                        <BSSMenu {...{MenuProps}} rightAlignment={false} >
                                            {/* <Paper sx={{width: 320, boxShadow: "none", paddingLeft: 1}}> */}
                                            <RadioGroup value={mostraSolo} onChange={e => setMostraSolo(e.target.value)}>
                                                <MenuList dense sx={{paddingX: 1, minWidth: 250}}>
                                                    {Object.keys(mappaTipi).map((v, i) => {
                                                        return (
                                                            <MenuItem key={i}> 
                                                                <FormControlLabel value={v} 
                                                                    control={<Radio />} 
                                                                    label={mappaTipi[v]} 
                                                                />
                                                                
                                                            </MenuItem>
                                                        )
                                                    })}                                                                                                       
                                                </MenuList>
                                            </RadioGroup>
                                            {/* </Paper> */}
                                        </BSSMenu>
                                    </>
                                )
                            }}
                            AutocompleteProps={{
                                blurOnSelect: true, 
                                clearOnBlur: true,
                                filterOptions: (options, state) => {
                                    const term = state?.inputValue ?? "";
                                    return searchContatti([...(contatti ?? [])], term, parametroTipoSearchContatti);
                                },
                                groupBy: (option) => {
                                    const mod = (option?.proponiper?.value ?? "E");
                                    return (
                                        <Typography variant={"body"} style={{textAlign: "right", color: theme.palette.secondary.main}}>
                                            {__t(mod === "M" ? "mittenti" : mod === "D" ? "destinatari" : "entrambe").toUpperCase()}                                                                 
                                        </Typography>
                                    )
                                },
                                getOptionLabel: (option) => {
                                    return ``
                                },
                                onChange: (e, v) => {
                                    const contatto = contattoByIndirizzo(v);
                                    vediContatto(e, contatto);                                    
                                },
                                renderOption: (props, option, { selected }) => {

                                    const contatto = contattoByIndirizzo(option);
                                    
                                    const indirizzo = {...option.indirizzoOri};

                                    const {labelParts} = option.indirizzoCompleto;
                                    const {indirizzoLabel, localitaLabel, contattareLabel, defaultLabel} = labelParts;

                                    return (
                                        <li {...props} style={{flexDirection: "column"}} 
                                            //onClick={e => modificaIndirizzo(e, contatto, indirizzo)}
                                        >    
                                            <Box width={1} display={"flex"}>
                                                <Box flexGrow={1}>
                                                    <Typography>
                                                        <Stack>                                                        
                                                            <Box>                                                                
                                                                {(indirizzo.def === true) && (<b>{defaultLabel.toUpperCase()}</b>)}
                                                                {" "}{indirizzoLabel}, {localitaLabel}                                                                
                                                            </Box>
                                                            <Box>{contattareLabel}</Box>
                                                        </Stack>
                                                    </Typography>
                                                    <UsaCome {...{inPreventivo, indirizzo, contattoSelezionato: contatto, indirizzoEnhanced: option.indirizzoCompleto}} />

                                                    {/* {option.label} */}
                                                </Box>
                                                
                                                    <Box textAlign={"right"}>   
                        
                                                        {/* <Stack>

                                                            {(indirizzo.prefisso) && (indirizzo.numero) && (
                                                                <Box textAlign={"right"}>
                                                                    <Link component={Button} target="_blank" href={`tel:${indirizzo.prefisso}${indirizzo.numero}`} > 
                                                                        <Phone />                                                                    
                                                                    </Link>   
                                                                </Box> 
                                                            )}  

                                                            {(indirizzo.prefisso) && (indirizzo.numero) && (
                                                                <Box textAlign={"right"}>
                                                                    <Link component={Button} target="_blank" href={`https://wa.me/${indirizzo.prefisso}${indirizzo.numero}`} > 
                                                                        <WhatsApp />                                                                    
                                                                    </Link>   
                                                                </Box> 
                                                            )}  

                                                            {(indirizzo.email) && (
                                                                <Box textAlign={"right"}>
                                                                    <Link component={Button} target="_blank" href={`mailto:${indirizzo.email}`} > 
                                                                        <AlternateEmail />                                                                    
                                                                    </Link>   
                                                                </Box> 
                                                            )} 
                                                            

                                                            <Box textAlign={"right"}>
                                                                <Button onClick={e => modificaIndirizzo(e, contatto, indirizzo)}> 
                                                                    <Edit />                                                                    
                                                                </Button>   
                                                            </Box> 
                                                        
                                                            <Box textAlign={"right"}>
                                                                <Button onClick={e => eliminaIndirizzo(e, contatto, indirizzo)}> 
                                                                    <Delete color="error" />                                                                    
                                                                </Button>  
                                                            </Box>                                                                                                                                                                                                                                                                    
                                                        </Stack> */}

                                                        
                                                    </Box>
                                                    
                                            </Box>                                    
                                            <Box width={1} mt={1} style={{textAlign: "right"}} border={"thin solid grey"}>
                                                <Typography variant="subtitle1">
                                                    <Button onClick={e => vediContatto(e, contatto)}>
                                                        {option.contatto.ragionesociale}
                                                    </Button> 
                                                    
                                                    <>
                                                        <Button onClick={e => creaIndirizzo(e, contatto)}>
                                                            <Add color="primary" />
                                                        </Button> 
                                                        <Button onClick={e => eliminaContatto(e, contatto)}>
                                                            <Delete color="error" /> 
                                                        </Button> 
                                                    </>
            
                                                    
                                                </Typography>    
                                                <Divider />

                                            </Box>
                                        </li>
                                    )
                                },
                                noOptionsText: __t("scrivipercercare"),
                                // afterChange: (data) => {
                                //     logger.debug("cambio ricerca contatti", data)
                                // }               
                            }}
                        />
                    </Grid>
                    
                    <Grid item alignItems="stretch" style={{display: "flex"}}>
                        <Button onClick={e => setStatoLista({
                            contattoSelezionato: {},
                            indirizzoSelezionato: null,
                            indSelMode: "crea"
                        })} variant="outlined">
                            <Add color="primary" />
                        </Button>
                    </Grid>                    
                    
                </Grid>
            </BSSForm>
        </FormProvider>
    )
}

const ListaContatti = ({classes, contatti, statoLista, setStatoLista, ricaricaContatti, inPreventivo}) => {

    const {contattoSelezionato = {}} = statoLista;
    const {listaindirizzi: indirizzi = []} = contattoSelezionato; 
    const [menuAzioniContatto, setMenuAzioniContatto] = useState({anchorEl: null, open: false})

    useEffect(()=> {

        const {contattoSelezionato = null, indirizzoSelezionato = null, indSelMode = null} = statoLista;

        logger.debug("contatti aggiornato", contatti)
        if((contatti ?? []).length > 0 && contattoSelezionato === null && indirizzoSelezionato === null && indSelMode === null){
            setStatoLista({
                ...statoLista,
                contattoSelezionato: contatti[0]
            })

        } else {
            if((contatti ?? []).length === 0){
                setStatoLista({
                    contattoSelezionato: {},
                    indirizzoSelezionato: null,
                    indSelMode: "crea"
                })
            }
        }
        
        
    }, [contatti])

    let ultimaLettera = null;

    const contattiDefault = contatti.reduce((obj, contatto) => {
        logger.debug("cerco i contatti di default", contatto);
        
        const {listaindirizzi} = contatto;
        const indirizzoDefault = listaindirizzi.find(indirizzo => indirizzo.def === true);

        if(![null, undefined].includes(indirizzoDefault)){

            const tipo = indirizzoDefault?.proponiper?.value ?? "E";

            if(tipo !== "E"){
                obj[tipo] = {
                    contatto,
                    indirizzo: indirizzoDefault
                }                
            }
            
        }

        return obj;
    }, {M: null, D: null})
    
    return (
        <>
            <AzioniContatto {...{menuAzioniContatto, setMenuAzioniContatto}} />

            <Box width={1}>
                <Box p={2}>
                    {/**todo risolvere problema form dentro form validateDOMNesting */}
                    <NavigaContatti contatti={contatti} setStatoLista={setStatoLista} inPreventivo={inPreventivo} menuAzioniContatto={menuAzioniContatto} setMenuAzioniContatto={setMenuAzioniContatto} />                    
                </Box>
                
            </Box>

            <Box width={1}> 
                
                {!(contattoSelezionato?.id ?? false) && (
                    <>
                        

                        <Grid container spacing={2} >

                            {
                                [{label: "M", text: "mittente"}, {label: "D", text: "destinatario"}].map((t, i) => {

                                    const contatto = contattiDefault[t.label];

                                    return (
                                        <Grid key={i} item sx={{width: 1}}>
                                            {contatto === null ? (
                                                <Typography sx={{paddingLeft: 2}} >
                                                    {__t(`nessun`)+" "+__t(`${t.text}default`)}
                                                </Typography>
                                            ) : (
                                                <>
                                                    <Indirizzo {...{
                                                        statoLista,
                                                        setStatoLista,
                                                        contattoSelezionato: contatto.contatto,
                                                        indirizzo: contatto.indirizzo,
                                                        mostraContatto: true,
                                                        mostraIndexIndirizzo: false,
                                                        ricaricaContatti,
                                                        inPreventivo,
                                                        menuAzioniContatto, 
                                                        setMenuAzioniContatto
                                                    }} />                                                    
                                                </>                     
                                            )}

                                        </Grid>
                                    )
                                })
                            }                           
                            
                        </Grid>

                        <Box width={1} display="flex" flexDirection="row"> 

                            <Box width={1}>           

                                {!(contatti?.length ?? 0) && (
                                    <Box p={2}>
                                        <Button fullWidth variant="contained" onClick={e => setStatoLista({
                                            contattoSelezionato: {},
                                            indirizzoSelezionato: null,
                                            indSelMode: "crea"
                                        })}>
                                            {__t("creaprimocontatto")}
                                        </Button>
                                        
                                    </Box>
                                )}                                                                                        

                                <List>
                                    {contatti.map((contatto, indiceContatto) => {

                                        let cambio = false;
                                        const iniziale = (contatto.ragionesociale ?? " ").toUpperCase()[0];
                                        if(iniziale !== ultimaLettera){
                                            ultimaLettera = iniziale;
                                            cambio = true;
                                        }

                                        const nindirizzi = contatto.listaindirizzi?.length ?? 0;

                                        const labelnindirizzi = nindirizzi === 0 ? __t("nessunindirizzo") :
                                            nindirizzi + " " + __t(`indirizz${nindirizzi === 1 ? 'o' : 'i'}`)

                                        return (
                                            <Fragment key={indiceContatto}>
                                                {cambio && (
                                                    <ListItem key={`cambio_lettera_${ultimaLettera}`}>
                                                        <Typography variant="h4">
                                                            {ultimaLettera}
                                                        </Typography>
                                                    </ListItem>
                                                )}
                                                <ListItem key={contatto.id}>
                                                    

                                                        <ListItemText>
                                                            <Typography variant="body1">
                                                                <Grid style={{display: 'flex'}}>
                                                                    <Grid item style={{flexGrow: 1, cursor: 'pointer'}}
                                                                        onClick={e => setStatoLista({
                                                                            ...statoLista,
                                                                            contattoSelezionato: contatto,
                                                                            indirizzoSelezionato: null, 
                                                                            indSelMode: null
                                                                        })}
                                                                    >
                                                                        <b>
                                                                            {contatto.ragionesociale.toUpperCase()} <small>({labelnindirizzi})</small>
                                                                        </b>
                                                                    </Grid>
                                                                    <Grid item>
                                                                        <Button onClick={e => setStatoLista({
                                                                                contattoSelezionato: contatto,
                                                                                indirizzoSelezionato: null,
                                                                                indSelMode: 'elimina'
                                                                        })}> 
                                                                            <Delete color="error" />                                                                    
                                                                        </Button>     
                                                                    </Grid>
                                                                </Grid>
                                                                                                                        
                                                            </Typography>
                                                            <Divider />
                                                        </ListItemText>
                                                    
                                                </ListItem>
                                            </Fragment>
                                        )
                                    })}
                                    
                                </List>                        
                            </Box>
                        </Box>
                    </>
                )}
            
                {(contattoSelezionato?.id ?? false) && (
                    <Box width={1}   style={{height: "100%", overflowY: "auto"}}>

                        <Box display="flex" flexDirection="row" px={2}>
                            <Box flexGrow={1}>

                                <Typography variant={"body1"} style={{fontWeight: "bold"}} >    

                                    <IconButton onClick={e => setStatoLista({
                                            contattoSelezionato: {},
                                            indirizzoSelezionato: null,
                                            indSelMode: null
                                    })}>
                                        <ArrowBackIos />
                                    </IconButton>

                                    {__t("indirizzi").toUpperCase()} {contattoSelezionato.ragionesociale.toUpperCase()}
                                </Typography>
                            </Box>
                            <Box pt={1}>
                                <Button onClick={e => setStatoLista({
                                    contattoSelezionato,
                                    indirizzoSelezionato: null,
                                    indSelMode: "crea"
                                })}>
                                    <Add color="primary" />
                                </Button>
                            </Box>
                        </Box>
                        
                        
                        <Box display="flex" flexDirection="row">
                            

                            <Box p={2} flexGrow={1}>
                                
                                <List  style={{paddingLeft: "0px"}}>
                                    {indirizzi.map((indirizzo, indexIndirizzo) => {

                                        return (
                                            <Indirizzo key={indexIndirizzo} {...{contattoSelezionato, indirizzo, indexIndirizzo, statoLista, setStatoLista, ricaricaContatti, inPreventivo, menuAzioniContatto, 
                                                setMenuAzioniContatto}} />
                                        )
                                    })}
                                </List>

                            </Box>
                        </Box>
                        
                    </Box>
                )}
                
            </Box>
        </>
    )
}

const AzioniContatto = ({setMenuAzioniContatto, menuAzioniContatto}) => {

    const {indirizzo = null, contattoSelezionato = null, setStatoLista = null, open = false, anchorEl = null} = menuAzioniContatto;

    const chiudiMenu = () => {
        setMenuAzioniContatto({
            open: false,
            anchorEl: null
        })
    }

    const MenuProps = {
        anchorEl,
        open,
        onClose: e => {chiudiMenu()},
    }


    return (indirizzo && contattoSelezionato) ? (
        <BSSMenu 
            {...{MenuProps}}
        >

            {(indirizzo.prefisso) && (indirizzo.numero) && (
                <MenuItem key="menu_telefono">
                    <Link component={Button} target="_blank" href={`tel:${indirizzo.prefisso}${indirizzo.numero}`} > 
                        <Phone /> {__t("telefona")}                                                                   
                    </Link>   
                </MenuItem> 
            )}  

            {(indirizzo.prefisso) && (indirizzo.numero) && (
                <MenuItem key="menu_whatsapp">
                    <Link component={Button} target="_blank" href={`https://wa.me/${indirizzo.prefisso}${indirizzo.numero}`} > 
                        <WhatsApp /> {__t("messaggia")}                                                                       
                    </Link>   
                </MenuItem> 
            )}  

            {(indirizzo.email) && (
                <MenuItem key="menu_email">
                    <Link component={Button} target="_blank" href={`mailto:${indirizzo.email}`} > 
                        <AlternateEmail /> {__t("email")}                                                                       
                    </Link>   
                </MenuItem> 
            )} 

            <MenuItem key="menu_modifica">
                <Button onClick={e => {
                    chiudiMenu();
                    setStatoLista({
                        contattoSelezionato,
                        indirizzoSelezionato: indirizzo,
                        indSelMode: 'modifica'
                    });
                }}>
                    <Edit color="primary" /> {__t("modifica")}    
                </Button>
            </MenuItem>
            <MenuItem key="menu_elimina">

                <Button onClick={e => {
                    chiudiMenu();
                    setStatoLista({
                        contattoSelezionato,
                        indirizzoSelezionato: indirizzo,
                        indSelMode: 'elimina'
                    });
                }}> 
                    <Delete color="error" /> {__t("elimina")}                                                                    
                </Button>     
            </MenuItem>

        </BSSMenu>
    ) : null
}

const Indirizzo = ({contattoSelezionato, indirizzo, statoLista, setStatoLista, 
    indexIndirizzo = 0, mostraContatto = false, mostraIndexIndirizzo = true, 
    ricaricaContatti, inPreventivo = false, menuAzioniContatto, setMenuAzioniContatto}) => {
    
    const indirizzoEnhanced = indirizzoMapper(contattoSelezionato, indirizzo)

    

    
    const {indirizzoSelezionato = null, indSelMode = null} = statoLista;
    const {id: idIndirizzoSelezionato} = indirizzoSelezionato ?? {}

    const inConfermaElimina = (
        indSelMode === "elimina" &&
        idIndirizzoSelezionato === indirizzo.id
    )

    const impostaDefault = async () => {
        
        const contatto = {
            ...indirizzo,
            proponiper: indirizzo?.proponiper?.value ?? 'E',
            def: true,
            contattodef: true
        }

        logger.debug("imposto il contatto di default da", indirizzo, "passando", contatto)

        await creaContatto(contatto);
        await ricaricaContatti();
    }

    const proponiper = indirizzo?.proponiper ?? null;

    return (
        <>
            <ListItem key={indirizzoEnhanced.id}>
                <ListItemText>

                    <Box py={2} style={{display: 'flex'}} flexDirection="row">
                        {mostraIndexIndirizzo && (
                            <Box py={2} pr={2} style={{verticalAlign: "center"}}>
                                #{indexIndirizzo+1}                                                        
                            </Box>
                        )}
                        
                        <Box flexGrow={1}>
                            {mostraContatto && (
                                <Typography>
                                    {contattoSelezionato.ragionesociale}
                                </Typography>
                            )}
                            {indirizzoEnhanced.label}     
                            {(indirizzo.def !== true && (proponiper?.value ?? "E") !== "E") && (
                                <Button onClick={e => impostaDefault()}>
                                    {__t("impostadefault", [__t(indirizzo.proponiper.label.toLowerCase())])}
                                </Button>                                                   
                            )}
                            
                            <UsaCome {...{inPreventivo, indirizzo, contattoSelezionato, indirizzoEnhanced}} />
                        </Box>
                        
                            
                        <Box textAlign={"right"}>
                            <Button onClick={e => setMenuAzioniContatto({
                                open: true,
                                anchorEl: e.currentTarget,
                                indirizzo,
                                setStatoLista,
                                contattoSelezionato
                            })} > 
                                <MoreVert />                                                                    
                            </Button>   
                        </Box>                                                             
                        
                    </Box>

                    
                    {/* <Divider /> */}
                </ListItemText>
            </ListItem>
        </>
    )
}

const FormNuovoContatto = ({classes, ricaricaContatti, initialValue = {}, statoLista, setStatoLista}) => {

    const mittdest = statoLista?.indirizzoSelezionato?.proponiper?.value ?? null;


    const valoreInizialeDaLista = {
        contatto: {
            ragionesociale: statoLista?.contattoSelezionato?.ragionesociale ?? null,
            proponiper: MittDestEnum?.[mittdest] ?? null,
            ...(statoLista?.indirizzoSelezionato ?? {}),        
        },
        ...(
            ((statoLista?.indirizzoSelezionato?.comune?.nazione?.iso ?? null) === "IT") ? {
                comune_contatto: statoLista?.indirizzoSelezionato?.comune ?? null 
            } : {
                cap_comune_contatto: statoLista?.indirizzoSelezionato?.comune?.cap ?? null, 
                comune_comune_contatto: statoLista?.indirizzoSelezionato?.comune?.comune ?? null 
            }
        ),
        nazione_contatto: statoLista?.indirizzoSelezionato?.comune?.nazione ?? null,
        provincia_contatto: statoLista?.indirizzoSelezionato?.comune?.provincia ?? {iso: ""}
        
    }


    const methods = useForm({ defaultValues: valoreInizialeDaLista });

    const {mainContainerWidth, theme} = useContext(BSSStyleContext);
    const cw = width2Breakpoint(mainContainerWidth, theme)

    const mittdestclasses = styles()

    const onSubmit = async (data) => {

        let provincia = {
            id: data.comune_contatto?.provincia?.id ?? null,
            provincia: data.comune_contatto?.provincia?.provincia ?? null,
            iso: data.comune_contatto?.provincia?.id ?? data.provincia_contatto ?? null
        };

        let comune = {
            id: data.comune_contatto?.id ?? null,
            cap: data.comune_contatto?.cap ?? data.cap_comune_contatto ?? null,
            comune: data.comune_contatto?.comune ?? data.comune_comune_contatto ?? null,
            provincia,
            nazione: data.nazione_contatto
        };
        
        let indirizzo = {...data.contatto.indirizzo, comune}

        let contatto = {

            ...data.contatto,
            proponiper: data?.contatto?.proponiper?.value ?? "M",
            comune
            //listaindirizzi: [indirizzo]
        }

        //delete contatto.indirizzo;

        logger.debug("submit contatto rubrica", data, "===>", contatto);

        await creaContatto(contatto)

        await ricaricaContatti()

    }

    const salvaContatto = e => {        
        methods.handleSubmit(onSubmit, DefaultSubmitErrorHandler)()
    }

    return (
        <>

            <Divider />

            <FormProvider {...methods}>
                        
                <BSSForm>  

                    <Grid item xs={12} className={classes.formGroupBox}>
                    
                    {/* <pre>{JSON.stringify(contatti, null, 2)}</pre> */}
                        <Contatto
                            {...{
                                methods,
                                ctx: "contatto",
                                datiPregressi: {},
                                cw,
                                fuoriSpedizione: true
                            }}
                        />

                        
                        <BSSButton methods={methods} type={"button"} onClick={salvaContatto} size="large" style={{fontWeight: "bolder"}} variant="contained" color="primary" fullWidth >
                            {`${__t("salvacontattorubrica")}`}
                        </BSSButton>       
                        
                    </Grid>
                </BSSForm>
            </FormProvider>
        </>
    )
}

export default Rubrica;
export {MittDestEnum, searchContatti, indirizzoMapper, contattiModifica, NavigaContatti, _Rubrica}